import React, { PureComponent } from "react";
import { Select } from "antd";
import PropTypes from "prop-types";
import { updateFilters } from "./../../redux/actions/photothequeActions";
import connect from "react-redux/es/connect/connect";

class BeforeAfterFilter extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: ""
    };
  }

  onChange(values) {
    this.props.addFilter(values);
  }

  render() {
    const Option = Select.Option;
    const { placeholder, defaultValue } = this.props;
    const children = [];
    const options = [
      {
        key: 2,
        value: "Tous"
      },
      {
        key: 0,
        value: "Avant"
      },
      {
        key: 1,
        value: "Après"
      }
    ];

    let i = 0;
    while (i < options.length && children.length < 10) {
      const option = options[i];
      if (!option) break;
      children.push(<Option key={option.key}>{option.value}</Option>);
      i++;
    }

    return (
      <Select
        // allowClear={true}
        filterOption={(input, option) => {
          return typeof option.props.children === "string"
            ? option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            : false;
        }}
        onFocus={() => {
          this.setState({
            searchValue: ""
          });
        }}
        onSearch={value => {
          this.setState({
            searchValue: value
          });
        }}
        mode="default"
        style={{ width: "100%" }}
        placeholder={placeholder}
        defaultValue={defaultValue}
        onChange={v => {
          this.onChange(v);
        }}
      >
        {children}
      </Select>
    );
  }
}

BeforeAfterFilter.propTypes = {
  placeholder: PropTypes.string.isRequired
};

const mapStateToProps = (state, ownProps) => {
  return {
    currentFilters: state.phototheque.currentFilters ? state.phototheque.currentFilters[ownProps.filterTargetKey] : []
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addFilter: values => {
      dispatch(updateFilters(ownProps.filterTargetKey, values));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BeforeAfterFilter);



// WEBPACK FOOTER //
// src/components/phototheque/BeforeAfterFilter.js